// src/reducers/settings.js

// It's good practice to define your action types as constants

const initialState = {
  // ...your existing settings state
  candleType: localStorage.getItem("candleType") || "D",
  histLen: localStorage.getItem("histLen") || "1Y",
  horizon: localStorage.getItem("horizon") || "1M",
  score: +localStorage.getItem("score") || 0,
  playMoney: +localStorage.getItem("playMoney") || 1000,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'SET_CANDLE_TYPE':
      localStorage.setItem("candleType", payload);
      return {
        ...state,
        candleType: payload,
      };
    case 'SET_HIST_LEN':
      localStorage.setItem("histLen", payload);
      return {
        ...state,
        histLen: payload,
      };
    case 'SET_HORIZON':
      localStorage.setItem("horizon", payload);
      return {
        ...state,
        horizon: payload,
      };
    case 'SET_SCORE':
      localStorage.setItem("score", payload);
      return {
        ...state,
        score: payload,
      };
    case 'SET_PLAY_MONEY':
      localStorage.setItem("playMoney", payload);
      return {
        ...state,
        playMoney: payload,
      };
    default:
      return state;
  }
}
